// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3qZMQ","label":"SetPasswdForm_label__3LT6E"};